var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147_74172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.112 172.115H142.183V125.243C142.183 114.066 141.983 99.677 126.616 99.677C111.027 99.677 108.642 111.855 108.642 124.429V172.112H78.7127V75.7235H107.445V88.8961H107.847C110.723 83.9795 114.878 79.9348 119.87 77.1928C124.862 74.4509 130.505 73.1143 136.197 73.3255C166.532 73.3255 172.125 93.2793 172.125 119.238L172.112 172.115V172.115ZM44.9408 62.5485C35.3482 62.5501 27.5704 54.7747 27.5688 45.182C27.5673 35.5894 35.3419 27.8116 44.9345 27.81C54.5272 27.8077 62.3049 35.5831 62.3065 45.1757C62.3074 49.7823 60.4783 54.2005 57.2216 57.4585C53.9649 60.7166 49.5474 62.5475 44.9408 62.5485M59.9062 172.116H29.9447V75.7235H59.9054V172.115L59.9062 172.116ZM187.034 0.0137252H14.9052C6.76994 -0.0778061 0.0984148 6.43906 -0.00100708 14.5743V187.421C0.0952585 195.56 6.76599 202.083 14.9044 201.998H187.034C195.189 202.099 201.886 195.576 201.999 187.421V14.5609C201.883 6.40987 195.185 -0.106212 187.034 0.000311103",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147_74172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 202,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.55892fb34413f679134f06291fce424e.svg";
export { ForwardRef as ReactComponent };